import { loadingCss } from "./index.styles";

export const Loading: React.FC = () => (
  <div css={loadingCss} role="alert" aria-busy="true">
    &nbsp;
  </div>
);
